module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_c('form', {
    staticClass: "form-horizontal",
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "q_avatar",
    on: {
      "mouseover": function($event) {
        _vm.showImageControl(true)
      },
      "mouseleave": function($event) {
        _vm.showImageControl(false)
      }
    }
  }, [_c('img', {
    ref: "projectImage",
    staticClass: "img img-responsive",
    attrs: {
      "src": _vm.formData.imageUrl == '' ? (_vm.formData.picture ? _vm.formData.picture : '/static/img/placeholder.png') : '/image/Project/' + _vm.formData.imageUrl + '?' + Date.now(),
      "border": "1"
    }
  }), _vm._v(" "), _c('div', {
    ref: "imageControl",
    staticClass: "q_form_image_controls"
  }, [_c('span', {
    staticClass: "icon ion-pencil pull-left q_select_file_button",
    attrs: {
      "title": "Edit"
    },
    on: {
      "click": function($event) {
        _vm.$refs.filePicture.click()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "icon ion-ios-trash-o pull-right q_clear_file_button",
    attrs: {
      "title": "Clear"
    },
    on: {
      "click": function($event) {
        _vm.clearPicture()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "q_hidden_input_file "
  }, [_c('input', {
    ref: "filePicture",
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.pictureChange
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "inputName"
    }
  }, [_vm._v("Name")]), _vm._v(" "), _c('h1', {
    staticStyle: {
      "margin-top": "0px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.name),
      expression: "formData.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": _vm.viewMode == _vm.MODE_VIEW,
      "id": "inputName",
      "placeholder": "Project Name"
    },
    domProps: {
      "value": (_vm.formData.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "name", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "nav-tabs-custom"
  }, [_c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', {
    class: {
      active: _vm.tabActive == _vm.TAB_GENERAL
    }
  }, [_c('a', {
    attrs: {
      "href": "#tab_1",
      "data-toggle": "tab",
      "aria-expanded": "true"
    }
  }, [_vm._v("General Info")])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane",
    class: {
      active: _vm.tabActive == _vm.TAB_GENERAL
    },
    attrs: {
      "id": "tab_1"
    }
  }, [_c('div', {
    staticClass: "box no-border"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputCompany"
    }
  }, [_vm._v("Company")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.companyId),
      expression: "formData.companyId"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.viewMode == _vm.MODE_VIEW ? true : false
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.formData, "companyId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.listCompany), function(row, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": row.id
      }
    }, [_vm._v("\n                                  " + _vm._s(row.name) + "\n                                ")])
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputCity"
    }
  }, [_vm._v("City")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.city),
      expression: "formData.city"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputCity",
      "placeholder": "",
      "disabled": _vm.viewMode == _vm.MODE_VIEW
    },
    domProps: {
      "value": (_vm.formData.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "city", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputSAPCode"
    }
  }, [_vm._v("SAP Code")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.sapCode),
      expression: "formData.sapCode"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputSAPCode",
      "placeholder": "",
      "disabled": _vm.viewMode == _vm.MODE_VIEW
    },
    domProps: {
      "value": (_vm.formData.sapCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "sapCode", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputTicketClosedTime"
    }
  }, [_vm._v("Closed Time of Ticket")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.ticketClosedTime),
      expression: "formData.ticketClosedTime"
    }],
    staticClass: "form-control timepicker",
    attrs: {
      "type": "text",
      "id": "inputTicketClosedTime",
      "placeholder": "",
      "disabled": _vm.viewMode == _vm.MODE_VIEW
    },
    domProps: {
      "value": (_vm.formData.ticketClosedTime)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "ticketClosedTime", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputBusinessArea"
    }
  }, [_vm._v("Business Area ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.businessArea),
      expression: "formData.businessArea"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputBusinessArea",
      "placeholder": "",
      "disabled": _vm.viewMode == _vm.MODE_VIEW
    },
    domProps: {
      "value": (_vm.formData.businessArea)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "businessArea", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputProfitCenter"
    }
  }, [_vm._v("Profit Center")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.profitCenter),
      expression: "formData.profitCenter"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputProfitCenter",
      "placeholder": "",
      "disabled": _vm.viewMode == _vm.MODE_VIEW
    },
    domProps: {
      "value": (_vm.formData.profitCenter)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "profitCenter", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputBusinessUnit"
    }
  }, [_vm._v("Business Unit")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.businessUnit),
      expression: "formData.businessUnit"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.viewMode == _vm.MODE_VIEW ? true : false
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.formData, "businessUnit", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.listBusinessUnit), function(row, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": row.id
      }
    }, [_vm._v("\n                                  " + _vm._s(row.name) + "\n                                ")])
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  })])])])])])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.id),
      expression: "formData.id"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "hidden",
      "id": "inputId"
    },
    domProps: {
      "value": (_vm.formData.id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "id", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.companyId),
      expression: "formData.companyId"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "hidden",
      "id": "inputCompanyId"
    },
    domProps: {
      "value": (_vm.formData.companyId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "companyId", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('div', {
    staticClass: "box-tools"
  }, [_c('button', {
    staticClass: "btn btn-default",
    staticStyle: {
      "margin-right": "15px"
    },
    on: {
      "click": function($event) {
        _vm.onBack()
      }
    }
  }, [_vm._v("Back")]), _vm._v(" "), (_vm.viewMode != _vm.MODE_VIEW) ? _c('button', {
    staticClass: "btn btn-warning",
    on: {
      "click": function($event) {
        _vm.onCancel()
      }
    }
  }, [_vm._v("Cancel")]) : _vm._e(), _vm._v(" "), (_vm.viewMode != _vm.MODE_VIEW) ? _c('button', {
    staticClass: "btn btn-info pull-right",
    on: {
      "click": function($event) {
        _vm.onSave()
      }
    }
  }, [_vm._v("Save")]) : _vm._e(), _vm._v(" "), (_vm.viewMode == _vm.MODE_VIEW) ? _c('button', {
    staticClass: "btn btn-info pull-right",
    on: {
      "click": function($event) {
        _vm.onEdit(_vm.formData)
      }
    }
  }, [_vm._v("Edit")]) : _vm._e(), _vm._v(" "), (_vm.viewMode == _vm.MODE_VIEW) ? _c('button', {
    staticClass: "btn btn-info pull-right",
    staticStyle: {
      "margin-right": "15px"
    },
    on: {
      "click": function($event) {
        _vm.onCreate()
      }
    }
  }, [_vm._v("Create")]) : _vm._e()])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-38fe0df8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/ProjectForm.vue
// module id = 759
// module chunks = 1